import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import ContentLayout from "../components/content-layout";
import Seo from "../components/seo"
import "../css/@wordpress/block-library/build-style/style.css"
import "../css/@wordpress/block-library/build-style/theme.css"

const FAQPostTemplate = ({ data: { post, id } }) => {

  return (
    <>
      <Seo title={post.seo.title} post={post} />
      <ContentLayout title={post.title} subtitle={parse(post.excerpt.replace(/(<([^>]+)>)/gi, ""))}>
        <div className="row">
          {!!post.content && (
            <div className="col-md-11 item page-content poker-rules">{parse(post.content)}</div>
          )}
        </div>
      </ContentLayout>
    </>
  )
}

export default FAQPostTemplate

export const pageQuery = graphql`
  query FAQPostByID( 
    $id: String! 
  ) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      date(formatString: "MMMM DD, YYYY") 
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(quality: 100, placeholder: BLURRED, layout: FULL_WIDTH)
            }
          }
        }
      }
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphImage {
          altText
          sourceUrl
          srcSet
          localFile {
            childImageSharp {
              gatsbyImageData(quality: 100, formats: [AUTO, WEBP, AVIF])
            }
          }
        }     
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
          localFile {
            childImageSharp {
              gatsbyImageData(quality: 100, formats: [AUTO, WEBP, AVIF])
            }
          }
        } 
        breadcrumbs {
            url
            text
        }
        cornerstone
        schema {
            pageType
            articleType
            raw
        }
        readingTime
        fullHead
      }        
    } 
  }    
`
